import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Money from '../../../common/money';
import Pagination from '../../../common/Pagination';
import {
  humanizeMembershipBillingFreq,
} from '../../../memberships/memberships/MembershipFormSteps/PricingStep/billingFrequencies';

const MembershipsList = props => (
  <div>
    <ul className="layout u-mb+">
      {
        props.activePageItems.map(mem => (
          <li
            key={mem.id}
            className="layout__item u-1/2 u-1/3-medium-and-up u-1/4-large-and-up"
          >
            <button
              type="button"
              onClick={() => props.selectMembership(mem)}
              className={cx('c-product-select-btn u-position-relative c-product-select-btn--primary', {
                'is-active': props.isMembershipSelected(mem),
              })}
            >
              <span className="o-center-content">
                <span className="c-product-select-btn__name">
                  {mem.name}
                </span>
                <span className="c-product-select-btn__price">
                  <Money>{mem.price}</Money> / {humanizeMembershipBillingFreq(mem.billingCycle)}
                </span>
              </span>
            </button>
          </li>
        ))
      }
    </ul>
    <Pagination
      display-if={props.activePageItems.length}
      onPageChange={props.openPage}
      pageCount={props.totalPages}
      currentPage={props.activePage}
    />
  </div>
);

MembershipsList.propTypes = {
  selectMembership: PropTypes.func.isRequired,
  isMembershipSelected: PropTypes.func.isRequired,
  activePageItems: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  activePage: PropTypes.number.isRequired,
  openPage: PropTypes.func.isRequired,
};

export default MembershipsList;
